import { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import type { UiLayoutGateway } from '@forq/platform-data';

/**
 * Trägt die beiden Dinge, die jede anpassbare Kachel-Reihe für die Persistenz braucht: den aktiven
 * Mandanten und das Layout-Gateway. So müssen die Seiten das Gateway nicht durch die halbe App reichen --
 * `CustomizableMetrics` (und künftige anpassbare Bereiche) holen sich beides aus dem Kontext.
 * Der An/Aus-Zustand des Bearbeiten-Modus liegt bewusst NICHT hier, sondern in `usePlatform().customizing`
 * (ein globaler Schalter, den auch die AppShell bedient).
 */
interface CustomizeContextValue {
  readonly tenantId: string;
  readonly gateway: UiLayoutGateway;
}

const CustomizeContext = createContext<CustomizeContextValue | null>(null);

export function CustomizeProvider({ tenantId, gateway, children }: PropsWithChildren<{ tenantId: string; gateway: UiLayoutGateway }>) {
  const value = useMemo(() => ({ tenantId, gateway }), [tenantId, gateway]);
  return <CustomizeContext.Provider value={value}>{children}</CustomizeContext.Provider>;
}

export function useCustomize(): CustomizeContextValue {
  const context = useContext(CustomizeContext);
  if (!context) throw new Error('useCustomize must be used inside CustomizeProvider.');
  return context;
}
